<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="3"
          lg="2"
        >
          <profileTabs />
        </b-col>
        <b-col
          cols="12"
          md="9"
          lg="10"
        >
          <router-view />
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import Profile from '@/views/logics/profile/Profile'
import profileTabs from './profileTabs.vue'

export default {
  components: {
    profileTabs,
  },
  mixins: [Profile],
}
</script>
